export default __webpack_public_path__ + "static/media/styles.ec2c24f5.less";